import generateFilterConfigs from "../../utils/FilterConfigGenerator";
import React, { useContext, useEffect, useState } from "react";
import FilterComponent from "../../components/complex/crud/FilterComponent";
import { Paginator } from "primereact/paginator";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { TabView, TabPanel } from "primereact/tabview";

import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Divider } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import UiContext from "../../store/ui-context";
import useAPIRequest from "../../custom_hooks/simple/useAPIRequest";
import { setLayoutDashboardTitle } from "../../store/ui-slice";

import { ProgressSpinner } from "primereact/progressspinner";
import {
  genElObject,
  genElText,
  genElDate,
  genElNumber,
} from "../../components/utils/EditorDialogElementGenerator";
import { InputText } from "primereact/inputtext";

const editTitle = "Edit Kendaraan";
const addTitle = "Tambah Pembayaran";

const title = "Retribusi Pembayaran Kendaraan";
const apiUrl = "kendaraanpembayaran";

const HistoriPembayaranEditorDialog = (props) => {
  const user = useSelector((state) => state.auth.user);

  const {
    visible,
    onHide,
    onConfirm,
    pembayaranType,
    data_kendaraan,
    data,
    setData,
    error,
    setError,
    loading,
  } = props;

  // const [data, setData] = useState({ jumlah: 0, tanggal_bayar: "" });
  const [addNewMode, setAddNewMode] = useState([]);

  const uiContext = useContext(UiContext);
  const dispatch = useDispatch();

  const [listData, setListData] = useState([]);

  // dialog state

  /**
   * Validates the form data.
   *
   * @returns {boolean} - Returns true if the data is valid, otherwise false.
   * @returns {object} - Returns an object containing the error messages, format { field: message}.
   */

  const validate = () => {
    let valid = true;
    let newEror = {};

    const tanggal_bayar = data.tanggal_bayar
      ? data.tanggal_bayar.trim()
      : data.tanggal_bayar;
    if (
      tanggal_bayar === "" ||
      tanggal_bayar === null ||
      tanggal_bayar === undefined
    ) {
      newEror = { ...newEror, tanggal_bayar: "Tanggal bayar harus diisi" };
      valid = false;
    }

    const jumlah = data.jumlah;
    if (jumlah === 0 || jumlah === null || jumlah === undefined) {
      newEror = { ...newEror, jumlah: "Jumlah harus diisi" };
      valid = false;
    }

    if (!valid) setError(newEror);

    return valid;
  };

  const convertSaveData = (data) => {
    const newData = { ...data };
    newData.diproses_id = user.data_karyawan.id;
    newData.kendaraan_id = data_kendaraan.id;
    newData.tahun = new Date(data.tanggal_bayar).getFullYear();
    newData.tipe = pembayaranType;
    newData.status = 0;
    return newData;
  };

  // useEffect section

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
    // fetchData({ id: data.id });
  }, []);

  useEffect(() => {
    if (visible) {
    }
  }, [visible]);

  // API Call Section

  // handle UI event section

  /**
   * Generate Dialog Form Element
   *
   * various function to generate
   *
   * genElText({ field, name, data, setData, disabled, autoFocus, error })
   * genElTextPassword({ field, name, data, setData, disabled, autoFocus, error })
   * genElTextDropdown({ field, name, data, setData, options, disabled, autoFocus, error, optionLabel = "name" })
   * genElNumber({ field, name, data, setData, min_fraction_digits, max_fraction_digits, min, max, disabled, autoFocus, error })
   * genElNumberDropdown({ field, name, data, setData, options, disabled, autoFocus, error, optionLabel = "name" })
   * genElBoolean({ field, name, data, setData, labelTrue = "Ya", labelFalse = "Tidak", disabled, autoFocus, error })
   * genElDate({ field, name, data, setData, primeFormat, min, max, showTime, time, month, year, disabled, autoFocus, error })
   * genElObject({ field, name, value, onClick, selectorGenerator, disabled, autoFocus, error })
   */

  const elJumlah = genElNumber({
    field: "jumlah",
    name: "Jumlah",
    data,
    setData,
    error,
  });
  const elTanggalBayar = genElDate({
    field: "tanggal_bayar",
    name: "Tanggal Bayar",
    primeFormat: "dd MM yy",
    data,
    setData,
    error,
  });
  const elKeterangan = genElText({
    field: "keterangan",
    name: "Keterangan",
    data,
    setData,
    error,
  });

  const dialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        onClick={props.onHide}
      />
      <Button
        label="Save"
        icon="pi pi-check"
        loading={loading}
        onClick={(e) => {
          // handleConfirmSave(data);
          const valid = validate();
          if (valid) {
            onConfirm(convertSaveData(data));
          }
        }}
      />
    </React.Fragment>
  );

  return (
    <Dialog
      visible={visible}
      style={{ width: "24rem" }}
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header={addNewMode ? addTitle : editTitle}
      modal
      className={`p-fluid`}
      footer={dialogFooter}
      onHide={onHide}
    >
      <div className="col-start-center relative h-100">
        <div className="col-start-start w-80 gap-3">
          <div className="col-start-start w-100 gap-1">
            <label className="font-bold text-sm text-slate-500">
              Nomor Polisi{" "}
            </label>
            <InputText
              className={`w-full`}
              value={data_kendaraan.nomor_polisi}
              disabled
            />
          </div>

          <div className="col-start-start w-100 gap-1">
            <label className="font-bold text-sm text-slate-500">
              Jenis Mobil{" "}
            </label>
            <InputText
              className={`w-full`}
              value={data_kendaraan.jenis_mobil}
              disabled
            />
          </div>
        </div>
        <br />
        <Divider layout="horizontal" className="w-full" />
        <br />

        <div className="col-start-start w-80 gap-3">
          {elTanggalBayar}
          {elJumlah}
          {elKeterangan}
        </div>
        {loading && (
          <div
            className={`col-center-center w-100  gap-2 absolute z-100 h-full bg-black/20 rounded `}
          >
            <ProgressSpinner />
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default HistoriPembayaranEditorDialog;
